import { render, staticRenderFns } from "./moneyBoxDc.vue?vue&type=template&id=7a8912fe&scoped=true"
import script from "./moneyBoxDc.vue?vue&type=script&lang=js"
export * from "./moneyBoxDc.vue?vue&type=script&lang=js"
import style0 from "./moneyBoxDc.vue?vue&type=style&index=0&id=7a8912fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8912fe",
  null
  
)

export default component.exports